export const replaceLegacyCitationPlaceholder = (text: string): string => {
  const citationRegex = /<cite source="([\w-]+)"\s*\/?>/g;

  return text.replace(citationRegex, (_match, sourceId) => {
    if (!/^src-\w+$/.test(sourceId)) {
      console.warn(`Invalid citation format: ${sourceId}`);
    }
    return `::widget:citation:${sourceId}::`;
  });
};
